export default __webpack_public_path__ + "static/media/phone2.5c9d88f3.png";